

export const blogList4 = [
    {
      id: 1,
      title: 'Aerospace Engineering',
      category: 'AE',
      subCategory: ['frontend', 'ui/ux', 'design'],
      description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
      authorName: 'John Doe',
      authorAvatar: '/assets/images/author.jpg',
      cover: "/assets/images/aero.png",
      medium: 'https://medium.com/@swgiitkgp/know-your-department-aerospace-engineering-2f56a3572ffe'
    },
    {
        id: 2,
        title: 'Agricultural and Food Engineering',
        category: 'AG',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/agri.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-agricultural-and-food-engineering-99f88ff9d8a8'
    },
    {
        id: 3,
        title: 'Biotechnology',
        category: 'BT',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/bio.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-biotechnology-2e105384ce43'
    },
    {
        id: 4,
        title: 'Chemistry',
        category: 'CY',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/chem.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-chemistry-ce8973b56a67'
    },
    {
        id: 5,
        title: 'Chemical Engineering',
        category: 'CH',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/chemical.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-chemical-engineering-c54d2bc608d5'
    },
    {
        id: 6,
        title: 'Civil Engineering',
        category: 'CE',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/civil.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-civil-engineering-63caabd97cb0'
    },
    {
        id: 7,
        title: 'Computer Science and Engineering',
        category: 'CS',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/cs.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-computer-science-and-engineering-24392aab7146'
    },
    {
        id: 8,
        title: 'Electronics & Electrical Communication Engineering',
        category: 'EC',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/ece.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-electronics-and-electrical-communications-engineering-4bf6a043475'
    },
    {
        id: 9,
        title: 'Electrical Engineering',
        category: 'EE',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/ee.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-electrical-engineering-7a66cc2a80d3'
    },
    {
        id: 10,
        title: 'Geology and Geophysics',
        category: 'GG',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/ageo.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-geology-and-geophysics-31fd09664b3d'
    },
    {
        id: 11,
        title: 'Exploration Geophysics',
        category: 'EX',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/egeo.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-branch-exploration-geophysics-dd30c110b444'
    },
    {
        id: 12,
        title: 'Economics',
        category: 'HS',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/hss.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-branch-economics-67e8b350a5de'
    },
    {
        id: 13,
        title: 'Industrial and Systems Engineering',
        category: 'IM',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/indu.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-industrial-and-systems-engineering-50fe3321bd6d'
    },
    {
        id: 14,
        title: 'Instrumentation Engineering',
        category: 'IE',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/instru.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-branch-instrumentation-engineering-726b62c0ce78'
    },
    {
        id: 15,
        title: 'Mechanical Engineering',
        category: 'ME',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/mech.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-mechanical-engineering-bf4aaa54e8d'
    },
    {
        id: 16,
        title: 'Manufacturing Science and Engineering',
        category: 'MF',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/manu.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-branch-manufacturing-science-and-engineering-894e2a2346d2'
    },
    {
        id: 17,
        title: 'Mining Engineering',
        category: 'MI',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/mine.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-mining-engineering-2c37de00793f'
    },
    {
        id: 18,
        title: 'Mathematics',
        category: 'MA',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/mnc.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-mathematics-d5ad3ff992f4'
    },
    {
        id: 19,
        title: 'Metallurgical and Materials Engineering',
        category: 'MT',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/metal.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-metallurgical-and-materials-engineering-26d1070cec97'
    },
    {
        id: 20,
        title: 'Ocean Engineering and Naval Architecture',
        category: 'NA',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/ocean.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-ocean-engineering-and-naval-architecture-82ebca5c6bdf'
    },
    {
        id: 21,
        title: 'Physics',
        category: 'PH',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/physics.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-department-physics-da4bdb49af6b'
    },
    {
        id: 22,
        title: 'Quality Engineering Design & Manufacturing',
        category: 'QM',
        subCategory: ['frontend', 'ui/ux', 'design'],
        description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
        authorName: 'John Doe',
        authorAvatar: '/assets/images/author.jpg',
        cover: '/assets/images/quality.png',
        medium: 'https://medium.com/@swgiitkgp/know-your-branch-quality-engineering-design-and-manufacturing-69329b687d2e'
    }
  ];
